/**
 * DASHBOARD-RPS-GOLLAC-QUESTIONS-SKELETON.WIDGET
 * Skeleton adapté à dashboard-rps-gollac-questions.widget.tsx : 2 zones (exposés/sécurisés),
 * chacune un titre puis quelques lignes (topic/axe + question + barre de répartition +
 * pourcentage), avec un reflet qui balaie.
 */
import Skeleton, { SkeletonShine } from "@/components/skeleton"

const ROWS_PER_ZONE = 3

function SkeletonRow() {
  return (
    <div className="flex items-center" style={{ gap: 24, padding: "12px 0" }}>
      <div className="flex1">
        <Skeleton width={220} height={13} style={{ marginBottom: 8 }} />
        <Skeleton width={320} height={13} />
      </div>
      <div style={{ width: 280 }}>
        <Skeleton width="100%" height={18} borderRadius={12} />
        <Skeleton width={140} height={11} style={{ margin: "6px auto 0" }} />
      </div>
    </div>
  )
}

function SkeletonZone() {
  return (
    <div style={{ marginBottom: 40 }}>
      <Skeleton width={200} height={18} style={{ marginBottom: 20 }} />
      {Array.from({ length: ROWS_PER_ZONE }).map((_, i) => (
        <SkeletonRow key={i} />
      ))}
    </div>
  )
}

export default function DashboardRpsGollacQuestionsSkeletonWidget() {
  return (
    <div className="rel" style={{ overflow: "hidden" }}>
      <SkeletonZone />
      <SkeletonZone />
      <SkeletonShine />
    </div>
  )
}
